export default "__VITE_ASSET__DPLvyNir__"